import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["wrapper", "template"]
  static values = { wrapperSelector: { type: String, default: ".nested-fields" } }

  add(event) {
    event.preventDefault()
    const template = this.templateTarget
    const content = template.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    template.insertAdjacentHTML("beforebegin", content)
  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest(this.wrapperSelectorValue)
    if (!wrapper) return

    const destroyInput = wrapper.querySelector("input[name*='_destroy']")
    if (destroyInput) {
      destroyInput.value = "1"
      wrapper.style.display = "none"
    } else {
      wrapper.remove()
    }
  }
}
